var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('article',{staticClass:"container"},_vm._l((_vm.content),function(component){return _c(component.component,{key:component._uid,tag:"component",attrs:{"body":component}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }